import { render, staticRenderFns } from "./SolutionQualityChip.vue?vue&type=template&id=59a6797f&scoped=true&"
import script from "./SolutionQualityChip.vue?vue&type=script&lang=ts&"
export * from "./SolutionQualityChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a6797f",
  null
  
)

export default component.exports